<template>
  <router-view/>
</template>

<script>
export default {
  name: 'User',

  async created() {
    this.$root.$emit('initTheme');
    this.initialized = true;
    this.$root.$emit('initFavicon');
  },
};
</script>
